import React from 'react';
import {Row,Col,Typography} from  'antd'
const {Title,Text}=Typography;;
export default function TitleComponent() {
    return (
       <>
        {/* <Row>
        <Col
          lg={{ span: 22, offset: 0 }}
          xl={{ span: 22, offset: 0}}
          md={{ span: 22, offset: 1 }}
          sm={{ span: 22, offset: 1 }}
          xs={{ span: 22, offset: 1 }}
        >
          <Title level={3} style={{fontFamily:'Gilroy'}} >Welcome to Sourcewiz!</Title>
        </Col>
      </Row> */}
      <Row>
        <Col
          lg={{ span: 22, offset: 0 }}
          xl={{ span: 22, offset: 0 }}
          md={{ span: 22, offset: 1 }}
          sm={{ span: 22, offset: 1 }}
          xs={{ span: 22, offset: 1 }}
        >
          <Text type="secondary" style={{fontSize:'16px',}}>
          Manage all your products, and create custom catalogues for buyers in minutes!
          </Text>
        </Col>
      </Row>
       </>
    )
}
